// extracted by mini-css-extract-plugin
module.exports = {"colorPickerContainer":"TextAreaDialog_colorPickerContainer__3qqjC","colorBox":"TextAreaDialog_colorBox__AIYML"};